import { render, staticRenderFns } from "./AssessmentPreviousBatch.vue?vue&type=template&id=1d3a36a9"
import script from "./AssessmentPreviousBatch.vue?vue&type=script&lang=js"
export * from "./AssessmentPreviousBatch.vue?vue&type=script&lang=js"
import style0 from "./AssessmentPreviousBatch.vue?vue&type=style&index=0&id=1d3a36a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports